
export class MaintenanceRequest {
    assetMaintainanceId? : number;
    constructor(assetMaintainanceId? : number){
        this.assetMaintainanceId = assetMaintainanceId;

    }
}